/*
 * Copyright (c) Kalaora 2022.
 * Author: fharold
 *
 * hilo-oauth-manager
 * ServiceRepositoryHelper.ts
 */

import UserService from "./UserService";
import PolicyService from "./PolicyService";
import DeviceService from "./DeviceService";
import ServiceRepository from "../tools/service/ServiceRepository";
import KareviHTTPService from "../tools/service/KareviHTTPService";
import AuthenticationService from "../tools/service/AuthenticationService";
import OAuthHTTPService from "../tools/service/OAuthHTTPService";
import CategoryService from "./CategoryService";
import VideoService from "./VideoService";
import CatalogService from "./CatalogService";
import ProfileService from "./ProfileService";

export default class ServiceRepositoryHelper {

    static inject(svcRepo: ServiceRepository) {
        const kareviHTTPService = svcRepo.resolve(KareviHTTPService.id) as KareviHTTPService;
        const oauthHTTPService = svcRepo.resolve(OAuthHTTPService.id) as OAuthHTTPService;

        const authSvc = svcRepo.resolve(AuthenticationService.id) as AuthenticationService;

        const profileService =  new ProfileService(kareviHTTPService);
        svcRepo.insert(ProfileService.id, profileService);
        const userSvc = new UserService(oauthHTTPService, authSvc, profileService);

        svcRepo.insert(CategoryService.id, new CategoryService(kareviHTTPService));
        svcRepo.insert(CatalogService.id, new CatalogService(kareviHTTPService));
        svcRepo.insert(VideoService.id, new VideoService(kareviHTTPService));
        svcRepo.insert(DeviceService.id, new DeviceService(kareviHTTPService));
        svcRepo.insert(UserService.id, userSvc);
        svcRepo.insert(PolicyService.id, new PolicyService(userSvc));

        svcRepo.startServices();
    }
}